import { getDefaultStore } from 'jotai';
import { useEffect } from 'react';

import {
  type AvailableUpdate,
  availableUpdateAtom,
} from '@/features/appUpdate/atoms/availableUpdateAtom';

export function useOnAvailableAppUpdateInfo(
  listener: (info: AvailableUpdate) => void,
) {
  useEffect(() => {
    const store = getDefaultStore();
    return store.sub(availableUpdateAtom, () => {
      const availableUpdate = store.get(availableUpdateAtom);
      if (availableUpdate) {
        listener(availableUpdate);
      }
    });
  }, [listener]);
}
